<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M25.3 43.9c-.2 0-.3-.1-.4-.2L2.2 21.1c-.1-.1-.2-.3-.2-.4 0-.2.1-.3.2-.4l16-16c.1-.1.2-.2.4-.2s.3.1.4.2l5.7 5.7-7.3 7.3c-.6.6-.6 1.6 0 2.2 1.6 1.6 3.6 2.4 5.8 2.4 2.1 0 4.1-.8 5.6-2.3l1.2-1.2 10.4 10.5.1.1-3.7 3.7-4.4-4.4c-.3-.3-.7-.5-1.1-.5s-.8.2-1.1.5c-.6.6-.6 1.6 0 2.2l4.4 4.4-2.3 2.3-4.4-4.4c-.3-.3-.7-.5-1.1-.5s-.8.2-1.1.5-.5.7-.5 1.1c0 .4.2.8.5 1.1l4.4 4.4-4.4 4.4c-.1.1-.3.1-.4.1z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M41.7 25.5c-.2 0-.3-.1-.4-.2L31.2 15.1c-.3-.3-.7-.5-1.1-.5s-.8.2-1.1.5l-2.3 2.3c-.9.9-2.1 1.4-3.4 1.4-.8 0-1.6-.2-2.3-.6L31.6 7.4c.1-.1.3-.2.4-.2.2 0 .3.1.4.2l13.4 13.4c.1.1.2.3.2.4 0 .2-.1.3-.2.4L42 25.3c-.1.1-.2.2-.3.2z" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
